/**
 * Config: Algolia
 * -----------------------------------------------------------------------------
 * Global configuration for storing Algolia index references.
 *
 */

export const indexPrefix = cnvs.algolia.indexPrefix
export const defaultIndex = `${indexPrefix}${cnvs.algolia.defaultSortingOption}`
export const priceAscendingIndex = `${indexPrefix}products_price_asc`
export const priceDescendingIndex = `${indexPrefix}products_price_desc`
export const titleAscendingIndex = `${indexPrefix}products_title_asc`
export const titleDescendingIndex = `${indexPrefix}products_title_desc`
export const suggestionIndex = `${indexPrefix}products_query_suggestions`
export const collectionIndex = `${indexPrefix}collections`
export const pageIndex = `${indexPrefix}pages`

export const algoliaIndicies = {
  product: defaultIndex,
  productPriceAscending: priceAscendingIndex,
  productPriceDescending: priceDescendingIndex,
  productTitleAscending: titleAscendingIndex,
  productTitleDescending: titleDescendingIndex,
  suggestion: suggestionIndex,
  collection: collectionIndex,
  page: pageIndex,
}